import { vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "_mt-1" }
const _hoisted_4 = { class: "_pl-6 _pr-6" }
const _hoisted_5 = {
  class: "_mt-3 _tac",
  "data-qa": "login-form:SignUp"
}
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  class: "_mt-3 _tac",
  "data-qa": "login-form:ForgotPassword"
}
const _hoisted_8 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("fieldset", null, [
      _createVNode(_component_field, {
        name: "model.email",
        class: "_mt-0",
        "display-name": _ctx.Resources.Account.EmailFieldLabel,
        "data-qa": "login-form:Email"
      }, {
        default: _withCtx(({ fieldId }) => [
          _withDirectives(_createElementVNode("input", {
            id: fieldId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.email) = $event)),
            class: "gfu-field__input",
            type: "email",
            name: "email",
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent","stop"]), ["enter"])),
            "data-qa": "text-field-input"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1), [
            [_vModelText, $data.model.email]
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["display-name"]),
      _createVNode(_component_field, {
        name: "model.password",
        "display-name": _ctx.Resources.Account.PasswordFieldLabel,
        "data-qa": "login-form:Password"
      }, {
        default: _withCtx(({ fieldId }) => [
          _withDirectives(_createElementVNode("input", {
            id: fieldId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.model.password) = $event)),
            class: "gfu-field__input",
            type: "password",
            name: "password",
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent","stop"]), ["enter"])),
            "data-qa": "text-field-input"
          }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
            [_vModelText, $data.model.password]
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["display-name"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_field, null, {
          default: _withCtx(() => [
            _createElementVNode("button", {
              type: "button",
              class: "gfu-btn gfu-btn--accent gfu-btn--block gfu-btn--soft gfu-btn__text",
              onClick: _cache[4] || (_cache[4] = _withModifiers((...args) => ($options.submit && $options.submit(...args)), ["stop","prevent"])),
              "data-qa": "login-form:Login"
            }, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.Resources.Account.LogInButton), 1 /* TEXT */)
            ])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          href: $options.signUpUrl,
          class: "gfu-link gfu-link--accent",
          onClick: _cache[5] || (_cache[5] = (...args) => ($options.onSignUpLinkClick && $options.onSignUpLinkClick(...args)))
        }, _toDisplayString(_ctx.Resources.Account.SignUpLink), 9 /* TEXT, PROPS */, _hoisted_6)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          href: $options.resetPasswordUrl,
          class: "gfu-link gfu-link--accent"
        }, _toDisplayString(_ctx.Resources.Account.ForgotPasswordLink), 9 /* TEXT, PROPS */, _hoisted_8)
      ])
    ]),
    _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
  ]))
}